@if (directStepService.step$ | async; as directQuestion) {
  @if (directQuestion) {
    <lib-step-supplier
      [sessionId]="generateHash()"
      [isFetching]="(directStepService.isFetching$ | async)!"
      [step]="directQuestion"
    />
  }
} @else {
  <ion-skeleton-text [animated]="true" />
  <ion-skeleton-text [animated]="true" />
  <ion-skeleton-text [animated]="true" />
}
